/**
 * ForbiddenRequestError
 *
 * @example
 * {
 *   message: "You are not authorized to access this resource."
 * }
 */
export type ForbiddenRequestError = {
  message: string
}

export function isForbiddenRequestError(
  data: unknown,
  responseStatus?: number
): data is ForbiddenRequestError {
  if (responseStatus !== 403) {
    return false
  }

  return (
    typeof data === 'object' &&
    data !== null &&
    'message' in data &&
    typeof data.message === 'string'
  )
}
